// src/activation/ActivationBridge.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { ActivationProvider } from './ActivationProvider';

function clean(v) {
  const s = (v ?? '').toString().trim();
  return s && s !== 'null' && s !== 'undefined' ? s : '';
}

function readKeys() {
  return {
    schoolId: clean(reactLocalStorage.get('current-school')),
    session : clean(reactLocalStorage.get('session')),
    term    : clean(reactLocalStorage.get('term')),
    developerBypass: clean(reactLocalStorage.get('developer-subscription-bypass')),
    platformConsole: clean(reactLocalStorage.get('platform-console')),
  };
}

export default function ActivationBridge({ children }) {
  const [keys, setKeys] = useState(readKeys);

  useEffect(() => {
    const onChange = () => setKeys(readKeys());
    window.addEventListener('storage', onChange);
    window.addEventListener('school-ctx-changed', onChange);

    // ensure initial sync (in case LS was just written)
    onChange();
    return () => {
      window.removeEventListener('storage', onChange);
      window.removeEventListener('school-ctx-changed', onChange);
    };
  }, []);

  const { schoolId, session, term, developerBypass, platformConsole } = keys;

  // Force a provider remount whenever any key changes
  const providerKey = useMemo(
    () => `${schoolId}|${session}|${term}|${developerBypass}|${platformConsole}`,
    [schoolId, session, term, developerBypass, platformConsole]
  );

  return (
    <ActivationProvider
      key={providerKey}
      schoolId={schoolId}
      session={session}
      term={term}
      developerBypassToken={developerBypass}
    >
      {children}
    </ActivationProvider>
  );
}
